import { ContainerMappingContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const ContainerMappingPage = () => {
  return (
    <PageFrame>
      <ContainerMappingContainer />
    </PageFrame>
  );
};
